<template>
    <div class="py-4 offersd">
        <div class="container">
          
            <b-container class="text-center px-0">
				<b-row class="mb-4" v-for="rowIdx in Math.ceil(toporders.length / columInarow)" :key="rowIdx">
					<b-col class="relative"  v-for="item in toporders.slice(columInarow * (rowIdx - 1), columInarow * rowIdx)" :key="item">
							<b-link :href="'/brand/'+item.urlslug"  >
							  <!-- <b-img-lazy v-bind="mainProps"  :src="$root.MEDIAPATH+'brands/'+item.brand_logo" fluid ></b-img-lazy> -->
							  <b-img-lazy v-bind="mainProps"  :src="$root.MEDIAAPI+'tool/get_image?size=283x315&src='+$root.MEDIAPATH+'brands/'+item.brand_logo" fluid ></b-img-lazy> 
							  
							  
							  <!--$root.MEDIAAPI+'toolimage/get_image?size='+phoneImageWidth+'x'+phoneImageHeight+'&src='+data -->
							  
                              <div class="absolute">
                                <p class="mb-2 desc" >{{item.title}}</p>
                                <b-button size="lg" rounded="top" class="offer-btn" >UPTO {{$root.tofixed(item.topdiscount)}}% OFF</b-button>
                              </div>
							 </b-link>
                        </b-col> 
				
				
				
				 <!--<b-col   v-for="item in toporders.slice(columInarow * (rowIdx - 1), columInarow * rowIdx)" :key="item"> 
				
					<b-link :href="'/brand/'+item.urlslug"> 
						<div class="pageview">
							<b-img :src="$root.MEDIAAPI+'tool/get_image?size=400x400&src='+$root.MEDIAPATH+'brands/'+item.brand_logo"  fluid-grow alt="Fluid-grow image" class="moreOfferImgHeight"></b-img>
							
							<div class="imginfo">
								<p class="title">Upto {{item.topdiscount || 0}}% OFF</p>
								
							</div>
							
						</div>
					</b-link>
					
				</b-col> -->
			
			</b-row >
			
			
			
			
				<!--{{toporders}} -->
            </b-container>
        </div>
    </div>
</template>
<script>

//import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    name: 'HeroCarousel',
    components: { //VueSlickCarousel
	},
	mounted(){
		this.initload();
		
	  
	 if(window.innerWidth < 700){
			this.columInarow  = 2;
			
		 }
	},
    data() {
        return {
			mainProps: { class: 'm1', center: true,blankColor: '#fff',width:283,height:315},
			bannerItems:[		 
			 {img:"Dresses.jpg",title:"Dresses",url:"/category/fashion/fashion-women",offer:'66'},
			 {img:"Kurti&Kurtas.jpg",title:"Kurti & Kurtas",url:"/category/fashion/womens-clothing",offer:'58'},
			 {img:"T-Shirts.jpg",title:"T-Shirts",url:"/category/fashion/mens-clothing-western-wear",offer:'76'},
			 {img:"Shirts.jpg",title:"Shirts",url:"/category/fashion/mens-clothing-western-wear",offer:'30'},
			 {img:"Organic-Products.jpg",title:"Organic Products",url:"/category/organic",offer:'38'},
			 {img:"Cosmetic.jpg",title:"Cosmetic",url:"/category/cosmetics",offer:'48'},
			 {img:"SkinCare.jpg",title:"Skin Care",url:"/category/cosmetics/skin-care",offer:'38'},
			 {img:"MenShoes.jpg",title:"Men Shoes",url:"/category/fashion/mens-shoes",offer:'74'},
			 {img:"WomenShoes.jpg",title:"Women Shoes",url:"/category/fashion/womens-shoes",offer:'10'},
			 {img:"Accessories.jpg",title:"Accessories",url:"/category/fashion/fashion-women-accessories",offer:'50'}
			 ],
			topoffersurl: this.$root.WEBURL+'gettopoffers',
			toporders:[],
			allOffers:[],
			columInarow:4,
			mobilfilterlist: 0,
			
            settings: {
                "arrows": true,
                "dotsClass": "slick-dots custom-dot-class",
                "edgeFriction": 0.35,
                "infinite": true,
                "autoplay": false,
                "speed": 500,
                "cssEase": "linear",
                "slidesToShow": 4,
                "slidesToScroll": 1,
                "responsive": [
						{
						  "breakpoint": 1024,
						  "settings": {
							"slidesToShow": 3,
							"slidesToScroll": 3,
							"infinite": true,
							"dots": true
						  }
						},
						{
						  "breakpoint": 600,
						  "settings": {
							"slidesToShow": 2,
							"slidesToScroll": 2,
							"initialSlide": 2
						  }
						},
						{
						  "breakpoint": 480,
						  "settings": {
							"slidesToShow": 1,
							"slidesToScroll": 1
						  }
						}
					  ]
            },
			
        }
    },
	methods: {
			initload(){
				var self = this;
				self.axios.post(self.topoffersurl, {
					accesskey: self.$root.customer_info.access_key,
					/*category: this.$route.params.category,
					subcategory: categieyName,
					filter:self.filterQuery,
					page:self.nextPage*/
				}).then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						self.toporders=[];
						self.allOffers=[];
						var topOffer =  response.data.result.topOffers;
						//self.toporders =  topOffer;
						//self.toporders =  response.data.result.topOffers;
						//self.allOffers =  response.data.result.allOffers;
						//var allOffers =  response.data.result.allOffers;
						//console.log(response);
						
						topOffer.forEach(item => {
									
									if(item.topdiscount>0 && item.topdiscount!=null){
									self.toporders.push(item);
									}
									
									

							});
							
							/*allOffers.forEach(item => {
									if(item.topdiscount>0 && item.topdiscount!=null){
									self.allOffers.push(item);
									}

							}); */
						
					}
				}).catch(function (error) {
					alert(error);
				});
			
			
			}
		},

	
	
}
</script>
<style  lang="scss">
.offersd{
    .relative {
        position:relative;
    }
    .absolute {
        position: absolute;
        bottom: 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        left: 0;
        justify-content: center;
        overflow: hidden;
    }
    .offer-btn {
		width:85%;
        background: #f2f2f2;
        border-radius: 0 !important;
		border:0px;
        border-radius: 1rem 1rem 0rem 0rem !important;
        border-bottom-color: transparent !important;
        box-shadow: 0px 3px 55px rgba(0,0,0,0.5);
        color: black;
		&:hover {
			  background-color: #7954A1;
			  color:#fff;
			}
    }
	
	
	.slick-next {
		right: 21px;
	}
	
	.slick-prev {
		left: 25px;
		z-index: 999;
	}
		  
    .desc  {
        color: white;
        z-index: 0;
    }
	
	.slick{
		&-prev {
		  /*left: 3% !important;*/
		  top: 45% !important;
		  z-index: 10;
		  content:'\2212' !important ;
		  font: normal normal normal 14px/1 FontAwesome;
		  -webkit-transform: rotate(0deg);
		  transform: rotate(0deg);
			/*font-family: 'slick';
			font-size: 20px;
			line-height: 1;
			opacity: 0.75;
			border: 1px solid #c6c6c6;
			color: #683581;
			background: #fff;
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
			border-radius: 50%;
			content:'\2212' !important ; */
		  
		}
		&-next {
		 /* right: 3% !important;*/
		  top: 45% !important;
		  z-index: 10;
		   /* font-family: 'slick';
			font-size: 20px;
			line-height: 1;
			opacity: 0.75;
			border: 1px solid #c6c6c6;
			color: #683581;
			background: #fff;
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
			border-radius: 50%;
			content:\2212 !important ; */
			content:\2212 !important ;
			
		} 
	
	}
	
		@media only screen and (max-width:640px) {
		.offer-btn{
			font-size:15px;
		}
		
		}
	
	}
</style>